import styled from "styled-components";

const DocumentContainer = styled.div<{ hasSignatures: boolean }>`
  display: flex;
  height: calc(100vh - 250px);
  padding: 2px;
  width: 100%;
  margin: 0 auto;
  gap: ${({ hasSignatures }) => (hasSignatures ? "10px" : "0")};
`;

export default DocumentContainer;
